import React, { FC } from "react";
import CircularProgress from "../CircularProgress";
import Box from "../../display/Box";

const LoaderScreen: FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexGrow={1}
      pt={10}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoaderScreen;
